import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ISearchInputProps } from '@/@types/posts';

function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className,
}: ISearchInputProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border border-border bg-background-card px-3.5 py-2.5',
        className
      )}
    >
      <Search className="h-4 w-4 text-foreground-placeholder" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 bg-transparent text-sm text-foreground placeholder:text-foreground-placeholder outline-none"
      />
    </div>
  );
}

export { SearchInput };
